import http from "@/helper/http";

const initialState = () => ({
  deviceVersions: [],
  totalDeviceVersions: 0,
  loadingDeviceVersions: false,
  currentPage: 1,
  perPage: 20,
  platformFilter: "",
  productFilter: "",
  flavorFilter: "",
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    SET_DEVICE_VERSIONS(state, { device_versions, total }) {
      state.deviceVersions = device_versions || [];
      state.totalDeviceVersions = total || 0;
    },
    SET_LOADING(state, loading) {
      state.loadingDeviceVersions = loading;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_PLATFORM_FILTER(state, platform) {
      state.platformFilter = platform;
    },
    SET_PRODUCT_FILTER(state, product) {
      state.productFilter = product;
    },
    SET_FLAVOR_FILTER(state, flavor) {
      state.flavorFilter = flavor;
    },
    UPDATE_DEVICE_VERSION(state, updated) {
      const idx = state.deviceVersions.findIndex((v) => v.id === updated.id);
      if (idx !== -1) {
        state.deviceVersions.splice(idx, 1, updated);
      }
    },
    RESET_STATE(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    async fetchDeviceVersions({ commit, state }) {
      commit("SET_LOADING", true);
      try {
        const params = {
          page: state.currentPage,
          per_page: state.perPage,
        };
        if (state.platformFilter) {
          params.platform = state.platformFilter;
        }
        if (state.productFilter) {
          params.product = state.productFilter;
        }
        if (state.flavorFilter) {
          params.flavor = state.flavorFilter;
        }
        const response = await http.get("/v1/system/device/versions", {
          params,
        });
        commit("SET_DEVICE_VERSIONS", {
          device_versions: response?.data?.device_versions || [],
          total: response?.data?.total || 0,
        });
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async createDeviceVersion({ dispatch }, payload) {
      const response = await http.post("/v1/system/device/version", payload);
      await dispatch("fetchDeviceVersions");
      return response?.data;
    },
    async updateDeviceVersion({ commit }, { deviceVersionId, payload }) {
      const response = await http.patch(
        `/v1/system/device/version/${deviceVersionId}`,
        payload,
      );
      if (response?.data) {
        commit("UPDATE_DEVICE_VERSION", response.data);
      }
      return response?.data;
    },
    setPage({ commit, dispatch }, page) {
      commit("SET_PAGE", page);
      dispatch("fetchDeviceVersions");
    },
    setPlatformFilter({ commit, dispatch }, platform) {
      commit("SET_PLATFORM_FILTER", platform);
      commit("SET_PAGE", 1);
      dispatch("fetchDeviceVersions");
    },
    setProductFilter({ commit, dispatch }, product) {
      commit("SET_PRODUCT_FILTER", product);
      commit("SET_PAGE", 1);
      dispatch("fetchDeviceVersions");
    },
    setFlavorFilter({ commit, dispatch }, flavor) {
      commit("SET_FLAVOR_FILTER", flavor);
      commit("SET_PAGE", 1);
      dispatch("fetchDeviceVersions");
    },
  },
  getters: {
    deviceVersions: (state) => state.deviceVersions,
    totalDeviceVersions: (state) => state.totalDeviceVersions,
    loadingDeviceVersions: (state) => state.loadingDeviceVersions,
    currentPage: (state) => state.currentPage,
    perPage: (state) => state.perPage,
    platformFilter: (state) => state.platformFilter,
    productFilter: (state) => state.productFilter,
    flavorFilter: (state) => state.flavorFilter,
    totalPages: (state) => Math.ceil(state.totalDeviceVersions / state.perPage),
  },
};
